import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import isEmpty from 'validator/lib/isEmpty';
import { saveCustomerInfo } from '../../../store/actions/AuthAction';
import { connect } from 'react-redux';
import md5 from 'md5';
import HolalifeLogo from '../../../assets/images/Holalife.svg';
import Cookies from 'js-cookie';
import { handleLoginCookie } from '../../utils/cookies'
import { LoginController, LoginAuthnController } from '../../components/Product/Controllers/ProductApis';

function Login(props) {
    let history = useHistory();
    const [values, setValues] = useState({
        username: '',
        password: '',
    });
    const [infoErrorLogin, setInfoErrorLogin] = useState('');
    const deviceId = Cookies.get('__dvc'); //get cookie device ID
    const [dataApi, setDataApi] = useState({
        username: '',
        password: '',
        deviceId: deviceId,
        key: deviceId,
        rememberMe: 0,
        requestFrom: 'CMS_FACTORY',
    });

    let header = {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        Authorization: props.token,
    };
    const [validationMsg, setValidationMsg] = useState('');
    const onChangeUsername = (e) => {
        setValues({ ...values, username: e.target.value.trim() });
        setDataApi({ ...dataApi, username: e.target.value.trim() });
    };
    const onChangePassword = (e) => {
        setValues({
            ...values,
            password: e.target.value,
        });
        setDataApi({ ...dataApi, password: md5(e.target.value) });
    };
    //Nhấn enter đăng nhập
    const handleKeyDownLogin = (event) => {
        if (event.key === 'Enter') {
            handleLogin();
        }
    };
    //Validate
    const msg = {};
    const validateAll = () => {
        if (isEmpty(values.username) || !values.username.replace(/\s/g, '').length) {
            msg.username = 'Tên đăng nhập không được bỏ trống!';
        }
        if (isEmpty(values.password)) {
            msg.password = 'Mật khẩu không được bỏ trống!';
        } else {
            // if (values.password.length < 6) {
            //     msg.password = 'Mật khẩu phải có ít nhất 6 ký tự!';
            // }
        }

        setValidationMsg(msg);

        if (Object.keys(msg).length > 0) return false;
        return true;
    };
    const checkIssetCookie = () => {
        const deviceId = Cookies.get('__dvc'); //get cookie device ID
        if (!deviceId) {
            //sinh mới
            var currentDay = new Date();
            var dataSetCookie = md5(currentDay.getTime() + Math.floor(1000 + Math.random() * 9999));
            //set cookie bằng cách mã hóa md5(thời gian hiện tại nối với số ngẫu nhiên có 4 chữ số )
            Cookies.set('__dvc', dataSetCookie, currentDay.getTime() + 365 * 24 * 60 * 60, {
                path: '/',
            });
        }
    };

    //Handle login
    const handleLogin = async () => {
        const isValid = validateAll();
        var currentDay = new Date();
        var deviceId = md5(currentDay.getTime() + Math.floor(1000 + Math.random() * 9999));
        if (!isValid) return;
        
        // let response = await LoginController(JSON.stringify({
        //     ...dataApi,
        //     deviceId: dataApi.deviceId || deviceId,
        //     key: dataApi.deviceId || deviceId,
        // }), header);
        const {username, password} = dataApi
        let response = await LoginAuthnController({
            userName: username,
            password, 
            deviceId: 1,
            rememberMe: 1
        }, header);
        if (response.status === 200) {
            handleLoginCookie({
                username: response.data.userName || '',
                token: response.data.token || '',
                role: response.data.role || '',
            })
            // Cookies.set('user', JSON.stringify({
            //     username: response.data.userName || '',
            //     token: response.data.token || '',
            //     role: response.data.role || '',
            // }), {path: '/', domain: 'localhost'});
            
            //Set token vào Redux
            props.saveCustomerInfo({
                token: response.data.token,
                username: response.data.userName,
                role: response.data.role,
            });
            history.push('/')
        } else {
            setInfoErrorLogin(response.message);
        }
    };
    useEffect(() => {
        checkIssetCookie();
    }, []);

    return (
        <>
            {' '}
            <div className='container-scroller login-background'>
                <div className='container-fluid page-body-wrapper full-page-wrapper login-container'>
                    <div className='content-wrapper d-flex align-items-center auth login-content'>
                        <div className='row flex-grow'>
                            <div className='col-lg-4 mx-auto'>
                                <form>
                                    <div className='auth-form-light text-left p-5'>
                                        <div className='brand-logo'>
                                            <img alt='logo' src={HolalifeLogo} />
                                        </div>
                                        <div className='form-group'>
                                            <input
                                                name='username'
                                                className='form-control login-input '
                                                placeholder='Tài khoản'
                                                type='text'
                                                value={values.username}
                                                onChange={onChangeUsername}
                                                onKeyDown={handleKeyDownLogin}
                                            />
                                            <p className='text-danger'>{validationMsg.username}</p>
                                        </div>
                                        <input
                                            name='password'
                                            className='form-control login-input'
                                            placeholder='Mật khẩu'
                                            type='password'
                                            value={values.password}
                                            onChange={onChangePassword}
                                            onKeyDown={handleKeyDownLogin}
                                        />
                                        <p className='text-danger'>{validationMsg.password}</p>
                                        <p className='text-danger'>{infoErrorLogin}</p>
                                        <div className='mt-3'>
                                            <p className='text-danger'>{validationMsg.info}</p>
                                            <button
                                                type='button'
                                                className='btn-login'
                                                onClick={() => {
                                                    handleLogin();
                                                }}
                                            >
                                                Đăng nhập
                                            </button>
                                        </div>
                                        <div className='my-2 d-flex justify-content-between align-items-center'>
                                            <a
                                                href='avascript:void(0)'
                                                className='auth-link text-black'
                                            >
                                                Quên mật khẩu?
                                            </a>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
//======================================== END RENDER ================================================

//======================================== GET TOKEN =================================================

const mapStateToProps = (state) => {
    return {
        token: state.authReducer.detail.token,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        saveCustomerInfo: (data) => dispatch(saveCustomerInfo(data)),
    };
};

//====================================================================================================
export default connect(mapStateToProps, mapDispatchToProps)(Login);
